module.exports = __webpack_public_path__ + "img/thumbnail_Fossa_m_normal.981ff92b.png";